import type { Maybe } from '@adornis/base/utilTypes.js';
import type { EntityData } from '@adornis/baseql/entities/types.js';
import { context } from '@adornis/baseql/server/context.js';
import type { ColorDefinitions } from './entities/ColorDefinitions.js';

export type BHBaseQlContext = {
  institutionID: string;
  ignoreCapacity: boolean;
  participationStateChangeWasInitiatedByAdmin: boolean;
  colorDefinitions: Maybe<EntityData<ColorDefinitions>>;
};

export const bhBaseQlContext = (context ?? {}) as unknown as BHBaseQlContext;

export const setBHBaseQlConfig = (config: Partial<BHBaseQlContext>) => {
  bhBaseQlContext.institutionID = config.institutionID ?? bhBaseQlContext.institutionID;
  bhBaseQlContext.ignoreCapacity = config.ignoreCapacity ?? bhBaseQlContext.ignoreCapacity;
  bhBaseQlContext.participationStateChangeWasInitiatedByAdmin =
    config.participationStateChangeWasInitiatedByAdmin ?? bhBaseQlContext.participationStateChangeWasInitiatedByAdmin;
  bhBaseQlContext.colorDefinitions = config.colorDefinitions ?? bhBaseQlContext.colorDefinitions;
};
